<section class="loader-wrap">
    <div #loader class="loader" [ngClass]="size" id="loader">
        <!-- <div class="spinner"></div> -->
        <!-- <img src="assets/icons/admiral.png" alt=""> -->
        <!-- <div class="text">ADMIRAL</div> -->
        <!-- <span></span>
        <span></span>
        <span></span>
        <span></span> -->
    </div>
</section>